import { ChangeDetectionStrategy, Component } from '@angular/core'

import { IconUi } from './icon-ui'

@Component({
  selector: 'autocomplete-clear-icon',
  imports: [IconUi],
  template: `<icon-ui
    name="close"
    class="size-4" />`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutocompleteClearIcon {}

@Component({
  selector: 'autocomplete-loading-icon',
  template: ` <span class="border-primary-300 block size-4 animate-spin rounded-full border-2 border-t-transparent"> </span> `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutocompleteLoadingIcon {}
